import React from 'react';
import _, { find as _find, forEach as _forEach } from 'lodash';
import ReactDOM from 'react-dom';
import { Button } from 'react-bootstrap';
import withRouter from 'js/withRouter';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import FormCodeEditor from 'components/forms/FormCodeEditor';
import { FormGroup } from 'react-bootstrap';

const ContextModal = ({ children }) => {
  return ReactDOM.createPortal(children, document.getElementById('context-modal'));
};

class EmbeddedForms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormOptions: false,
      markerFromCFE: 'mark',
      selectedPlaceFromCFE: 'select',
      embeddedCode: ''
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.params[0] && prevProps.params[0]?.value !== this.props.params[0]?.value) {
      this.getEmbeddedCode();
    }
  };


  componentDidMount = () => {
    this.getEmbeddedCode();
  };

  showEmbeddedFormOptions = () => {
    this.setState({ showFormOptions: true });
  };

  handleIEclose = () => {
    this.setState({ showFormOptions: false });
  };

  changeEmbeddedCode = (name, value) => {
    this.setState({ embeddedCode: value });
  };

  getEmbeddedCode = () => {
    const { name: Tag, attributes, params } = this.props;
    const param = _find(params, ['name', attributes['data-name']]);
    const elements = [];
    if (param) {
      const output = param.value.split('#cc#');
      _forEach(output, (entry, i) => {
        const embeddedCode = entry.split('#aaa#');
        elements.push(embeddedCode);
      });
    }
    if (elements[1] !== undefined) {
      this.setState({ embeddedCode: elements[1][0] });
    }else{
      this.setState({ embeddedCode: undefined });
    }
  };

  setEmbeddedCode = () => {
    const { id, attributes, updateParam } = this.props;

    let param = '';
    param += '#cc#' + this.state.embeddedCode;

    const overflow = false;
    const default_image = false;
    const errors = [{ overflow, default_image }];
    updateParam(id, attributes['data-name'], param, errors);

    this.handleIEclose();
  };

  render() {
    const { name: Tag, attributes, disabled } = this.props;
    const { showFormOptions, embeddedCode, options } = this.state;
    const {
      intl: { messages },
    } = this.props;

    return (
      <>
        <Tag {...attributes} onClick={this.showEmbeddedFormOptions}>
          <>
            <div className="embeddedFormCSS">
              {embeddedCode ? (
                <div className="embedded-code-editor">
                  {messages?.embeddedForm.preview_not_available}
                </div>
              ) : (
                <div className="wrap">
                  <p>{messages?.embeddedForm.edit}</p>
                </div>
              )}
            </div>
          </>
        </Tag>

        {showFormOptions && !disabled && (
          <ContextModal>
            <div id="contextModalWrap">
              <div id="contextModalStage" className="row">
                <h3>{messages.embeddedForm.settings}</h3>
                <FormGroup className="em_form">
                  <FormCodeEditor
                    type="text"
                    label={messages.embeddedForm.embedded_code}
                    name="embeddedCode"
                    value={this.state.embeddedCode}
                    onChange={this.changeEmbeddedCode}
                    infoText="Beispielcode"
                  />
                </FormGroup>
                {messages.embeddedForm.preview_not_available}
                <div className="modal-default-style">
                  <Button variant="success" size="lg" onClick={this.setEmbeddedCode}>
                    {messages.editor.take_on}
                  </Button>
                  <Button variant="danger" size="lg" onClick={this.handleIEclose}>
                    {messages.editor.abort}
                  </Button>
                </div>
              </div>
            </div>
          </ContextModal>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(EmbeddedForms)));
